import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import MarketingShell from "./MarketingShell";
import PricingCards from "@/components/PricingCards";

export default function Pricing() {
    const { t } = useI18n();
    return (
        <MarketingShell>
            <section className="mx-auto max-w-5xl px-6 py-16 md:py-24">
                <div className="mb-12 text-center">
                    <h1 className="font-serif text-4xl font-bold tracking-tighter md:text-5xl">{t("marketing.pricingTitle")}</h1>
                    <p className="mt-4 text-lg text-muted-foreground">{t("marketing.pricingSub")}</p>
                </div>
                <PricingCards />
                <p className="mt-8 text-center text-sm text-muted-foreground">{t("marketing.trialNote")}</p>
            </section>
        </MarketingShell>
    );
}
